module.exports = __webpack_public_path__ + "img/8.170a2e8e.png";